enum Widths {
  PAGE_MAX = '1320px',
}

export default Widths;
